import { useCallback, useEffect, useState } from 'react';
import { useFormTokenChainContext } from './context/useFormTokenChainContext';
import { BreadCrumbCrumb } from '../types/types';

export const useBreadCrumbs = () => {
  const [breadcrumbs, setBreadcrumbs] = useState<BreadCrumbCrumb[]>([]);
  const { formTokens, getActualTokenFromUrl } = useFormTokenChainContext();

  const getBreadCrumbs = useCallback(() => {
    const activeToken = getActualTokenFromUrl();

    if (!activeToken) return [];

    const breadCrumbLabel =
      (activeToken.meta?.breadCrumbLabel as string) ?? activeToken.id ?? '';

    const items: BreadCrumbCrumb[] = [
      {
        url: activeToken.url,
        name: breadCrumbLabel,
        tokenId: activeToken.id,
        isActive: true,
      },
    ];

    const addToArray = (tokenId: string) => {
      const token = formTokens.nodes[tokenId];
      if (token) {
        items.push({
          url: token.url,
          name: (token.meta?.breadCrumbLabel as string) ?? token.id ?? '',
          tokenId: token.id,
          isActive: false,
        });

        if (token.parentTokenId) {
          addToArray(token.parentTokenId);
        }
      }
    };

    if (activeToken.parentTokenId) {
      addToArray(activeToken.parentTokenId);
    }

    const reversedItems = items.reverse();
    setBreadcrumbs(reversedItems);
  }, [formTokens, getActualTokenFromUrl]);

  useEffect(() => {
    getBreadCrumbs();
  }, [getBreadCrumbs]);

  return breadcrumbs;
};
